import script from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=7f4ec70c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4ec70c"]])

export default __exports__